import {
  CalendarPlus,
  CalendarMinus,
  UserPlus,
  Lock,
  LockOpen,
  Undo2,
  SquareCheck,
  Square,
  Puzzle,
  NotebookPen,
  ImagePlus,
  Flame,
  FileText,
  Copy,
  ChevronRight,
  ChevronLeft,
  ArchiveRestore,
  Archive,
  ArrowLeft,
  Building,
  Check,
  CheckCheck,
  ChevronDown,
  Clock,
  Cpu,
  Download,
  Ellipsis,
  Eye,
  Folder,
  House,
  KeyRound,
  LayoutGrid,
  LifeBuoy,
  ListChecks,
  LogIn,
  LogOut,
  type LucideIcon,
  Map as MapIcon,
  MonitorSmartphone,
  PanelTop,
  Pencil,
  Plug,
  Plus,
  RefreshCw,
  Search,
  Settings,
  Sparkles,
  Table,
  Trash2,
  TrendingUp,
  UserCog,
  Users,
  X,
} from 'lucide-react';
import { cn } from './cn';

/**
 * Icon names used by the module registry and the UI. A registry icon missing here fails the
 * registry test (C7), so menus never render a blank icon.
 */
export const ICONS = {
  'calendar-plus': CalendarPlus,
  'calendar-minus': CalendarMinus,
  'user-plus': UserPlus,
  lock: Lock,
  'lock-open': LockOpen,
  undo: Undo2,
  'square-check': SquareCheck,
  square: Square,
  puzzle: Puzzle,
  'notebook-pen': NotebookPen,
  'image-plus': ImagePlus,
  flame: Flame,
  'file-text': FileText,
  copy: Copy,
  'chevron-right': ChevronRight,
  'chevron-left': ChevronLeft,
  'archive-restore': ArchiveRestore,
  archive: Archive,
  'arrow-left': ArrowLeft,
  building: Building,
  check: Check,
  'check-check': CheckCheck,
  'chevron-down': ChevronDown,
  clock: Clock,
  cpu: Cpu,
  download: Download,
  ellipsis: Ellipsis,
  eye: Eye,
  folder: Folder,
  home: House,
  'key-round': KeyRound,
  'layout-grid': LayoutGrid,
  'life-buoy': LifeBuoy,
  'list-checks': ListChecks,
  'log-in': LogIn,
  'log-out': LogOut,
  map: MapIcon,
  'monitor-smartphone': MonitorSmartphone,
  'panel-top': PanelTop,
  pencil: Pencil,
  plug: Plug,
  plus: Plus,
  'refresh-cw': RefreshCw,
  search: Search,
  settings: Settings,
  sparkles: Sparkles,
  table: Table,
  'trash-2': Trash2,
  'trending-up': TrendingUp,
  'user-cog': UserCog,
  users: Users,
  x: X,
} as const satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS;

export const isIconName = (name: string): name is IconName => name in ICONS;

export function Icon({ name, className }: { name: string; className?: string }) {
  const Component = isIconName(name) ? ICONS[name] : Ellipsis;
  return <Component aria-hidden className={cn('shrink-0', className ?? 'size-4')} strokeWidth={2} />;
}
